export default function getCustom(subdomain: string, forceProtocol?: string) {
  if (!process.env.REACT_APP_DOMAIN) return
  const protocol = forceProtocol || process.env.REACT_APP_USE_HTTP ? 'http' : 'https'
  return `${protocol}://${subdomain}.${process.env.REACT_APP_DOMAIN}`
}
